import { io } from 'socket.io-client';
import { store } from '../store';
import { updateLastMessage, updateUnreadCount } from '../slices/contactsSlice';
import { appendMessage, removeTempMessage } from '../slices/messageSlice';
import { messageToast } from '../../utils/toast';
import { getChatContacts, getContacts } from './contact';
import config from './../../components/config';
import { getMessages } from './message';
import { getParamFromUrl } from '../../constants';
import { NotifyUser } from '../../utils/BrowserNotification';
import { isChatContactExists } from '../../utils';

const token = store.getState().authSlice.token || localStorage.getItem('token');

const baseURL = config.baseURL;

export const socket = io(baseURL, {
  autoConnect: false,
  transports: ['websocket', 'polling'],
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
  query: { token },
});

export const setupSocket = (userId) => {
  socket.on('connect', () => {
    socket.emit('join_user', { userId });
  });

  socket.on('reload_contact', handleReloadContact);
  socket.on('sent_new_message', handleSentNewMessage);
  socket.on('new_message', handleReceiveMessage);
  socket.on('mark_all_read', handleUnreadCount);
  socket.on('mark_as_unread', handleUnreadCount);
  socket.on('notification', handleNotification);
};

export const cleanupSocket = (userId) => {
  socket.emit('leave_user', { userId });

  socket.off('connect');
  socket.off('reload_contact');
  socket.off('sent_new_message');
  socket.off('new_message');
  socket.off('mark_all_read');
  socket.off('mark_as_unread');
  socket.off('notification');
};

export const handleReceiveMessage = (data) => {
  const { activeUser } = store.getState().messageSlice;
  const isContactExists = isChatContactExists(data?.contact_id);

  if (isContactExists && data) {
    handleUpdateLastMessage(data);
    handleNewMessage(data);

    if (Number(activeUser?.id) === Number(data.contact_id)) {
      socket.emit('mark_read', {
        contactId: data.contact_id,
        userId: store.getState().authSlice.user.id,
        messageId: data?.id,
      });
    }
  } else {
    handleReloadContact(data?.contact_id);
  }
};

export const handleUpdateLastMessage = (data) => {
  if (data) store.dispatch(updateLastMessage({ ...data, isReceivedMessage: true }));
};

export const handleNewMessage = (data) => {
  if (data) store.dispatch(appendMessage(data));
};

export const handleUnreadCount = (data) => {
  const { filters } = store.getState()?.filtersSlice;
  if (data) store.dispatch(updateUnreadCount({ ...data, unread: filters?.unread }));
};

export const handleNotification = (data) => {
  messageToast({ notification: data });
  NotifyUser({
    title: data?.user?.name,
    message: data?.message?.message,
  });
};

export const handleReloadContact = (contactId) => {
  const { activeUser } = store.getState().messageSlice;
  const { activeContactsPagination } = store.getState()?.contactsSlice;
  const { isChat, filters } = store.getState()?.filtersSlice;
  const isContactPage = window.location.pathname.includes('/contacts');

  if (isContactPage) {
    const status = Number(getParamFromUrl('status') ?? 1);
    getContacts({ status, ...filters });
  } else {
    getChatContacts({
      page: activeContactsPagination?.page || 1,
      ...filters,
    });

    if (!isChat) {
      getContacts({
        ...filters,
        type: 'CHAT',
        status: 1,
      });
    }
  }

  if (contactId && contactId === activeUser?.id) {
    getMessages(activeUser?.id);
  }
};

export const handleSentNewMessage = (data) => {
  const isContactExists = isChatContactExists(data?.contact_id);
  if (isContactExists && data) {
    store.dispatch(removeTempMessage());
    store.dispatch(updateLastMessage({ ...data, isReceivedMessage: false }));
    store.dispatch(appendMessage(data));
  } else {
    handleReloadContact(data?.contact_id);
  }
};
